/** Removes duplicates and falsy values (empty strings, null, undefined), keeping first-seen order. */
export const unique = <T>(items: T[]): T[] => Array.from(new Set(items.filter(Boolean)));
